import NextImage from 'next/image';
import { Mail, Phone } from 'lucide-react';
import type { ContactItem } from '@/types/contact';

interface ContactOfficeContactLinkProps {
  item: ContactItem;
  emailIconUrl: string | null;
  phoneIconUrl: string | null;
}

export default function ContactOfficeContactLink({
  item,
  emailIconUrl,
  phoneIconUrl,
}: ContactOfficeContactLinkProps) {
  const href = item.urlOptional?.trim();
  const label = item.heading?.trim() || '';
  if (!label || !href) return null;

  const isEmail = href.startsWith('mailto:');
  const iconUrl = isEmail ? emailIconUrl : phoneIconUrl;

  let icon: React.ReactNode;
  if (iconUrl) {
    icon = (
      <NextImage
        src={iconUrl}
        alt=""
        width={11}
        height={11}
        className="h-[11px] w-[11px] shrink-0"
      />
    );
  } else if (isEmail) {
    icon = <Mail size={11} strokeWidth={2} className="shrink-0 text-[#E31E24]/60" />;
  } else {
    icon = <Phone size={11} strokeWidth={2} className="shrink-0 text-[#E31E24]/60" />;
  }

  return (
    <a
      href={href}
      className={`flex items-center gap-2 text-[12px] transition-colors hover:text-[#E31E24] ${
        isEmail ? 'mb-1.5 text-black/50' : 'font-semibold text-black/65'
      }`}
    >
      {icon}
      {label}
    </a>
  );
}
